/**
 * CAS（careecon_cas）の oauth 画面へ遷移するときに付ける client_id。
 * CAS はこの値（CAS の Service.code）で遷移元サービスを特定する。
 */
export var CasClientId = 'careecon_work';
/**
 * CAS の URL に client_id を付けて返す。
 * すでにクエリがある URL（招待リンクなど）は `&` でつなぎ、client_id が既にあれば付け足さない。
 */
export var withCasClientId = function (url) {
    if (/[?&]client_id=/.test(url)) {
        return url;
    }
    var separator = url.includes('?') ? '&' : '?';
    return "" + url + separator + "client_id=" + CasClientId;
};
